import { render, staticRenderFns } from "./ChooseBeneficiariesEmpty.vue?vue&type=template&id=3631b610&scoped=true&"
import script from "./ChooseBeneficiariesEmpty.vue?vue&type=script&lang=js&"
export * from "./ChooseBeneficiariesEmpty.vue?vue&type=script&lang=js&"
import style0 from "./ChooseBeneficiariesEmpty.vue?vue&type=style&index=0&id=3631b610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631b610",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VExpandTransition,VFlex,VLayout,VSelect})
